var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pic-preview"}},[_c('div',{staticClass:"background",on:{"click":_vm.close}},[_c('div',{staticClass:"picWrap"},[_c('img',{ref:"pic",style:(_vm.picStyle()),attrs:{"src":_vm.picUrl,"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }